module.exports = __webpack_public_path__ + "img/linode.72ae9a55.svg";